import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { cn } from "@/lib/utils";
import { Empty } from "@/components/Common";
import { Avatar, Hold, Tape } from "@/components/Brand";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { X } from "lucide-react";

function AvatarPopup({ row, onClose }) {
  return (
    <Dialog open={!!row} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xs overflow-hidden p-0 [&>button.absolute]:hidden" data-testid="leaderboard-avatar-dialog">
        {row && (
          <>
            <div className="relative">
              {row.avatar ? <img src={row.avatar} alt={row.display_name} className="aspect-square w-full object-cover" data-testid="leaderboard-avatar-large" />
                : <div className="flex aspect-square w-full items-center justify-center bg-[#EFEBDD]"><Avatar name={row.display_name} size={140} /></div>}
              <button onClick={onClose} aria-label="Tutup" className="absolute right-3 top-3 flex h-10 w-10 items-center justify-center rounded-full bg-[#1A3323]/85 text-[#FDFCF8] shadow-lg" data-testid="leaderboard-avatar-close"><X className="h-5 w-5" /></button>
            </div>
            <div className="p-4 text-center">
              <DialogTitle className="text-lg font-extrabold text-[#1A3323]">{row.display_name}</DialogTitle>
              <DialogDescription className="mt-0.5">{row.community || "Climber iyalagi.manjat"} · #{row.rank} · {row.completed} climb</DialogDescription>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}

export function LeaderboardList({ endpoint }) {
  const [period, setPeriod] = useState("all");
  const [items, setItems] = useState(null);
  const [viewing, setViewing] = useState(null);
  const { activeProfile } = useAuth();
  const pid = activeProfile?.id;
  useEffect(() => {
    setItems(null);
    api.get(endpoint, { params: { period, profile_id: pid } }).then((r) => setItems(r.data.items));
  }, [endpoint, period, pid]);
  return (
    <div className="space-y-4">
      <Tabs value={period} onValueChange={setPeriod}>
        <TabsList className="grid h-11 w-full max-w-sm grid-cols-2">
          <TabsTrigger value="all" data-testid="leaderboard-tab-all">All Time</TabsTrigger>
          <TabsTrigger value="month" data-testid="leaderboard-tab-month">Bulan Ini</TabsTrigger>
        </TabsList>
      </Tabs>
      {items && items.length === 0 && <Empty title="Belum ada climb" desc="Hanya climb yang ditandai Selesai oleh keeper yang dihitung. Yuk jadi yang pertama!" />}
      <div className="space-y-2" data-testid="leaderboard-list">
        {(items || []).map((r) => (
          <div key={r.rank} data-testid={`leaderboard-row-${r.rank}`}
            className={cn("relative flex items-center gap-3 overflow-hidden rounded-[18px] p-3 ring-1 ring-[#1A3323]/10", r.is_me ? "bg-[#E3EDD9] ring-2 ring-[#3D6F4B]" : r.rank <= 3 ? "bg-[#EFEBDD]" : "bg-white", r.rank <= 3 && "py-4")}>
            {r.rank <= 3 && <Hold className="absolute -bottom-5 left-16 h-10 w-12 rotate-12 opacity-30" color={r.rank === 1 ? "#1A3323" : "#7C9A6E"} />}
            <div className={cn("flex h-9 w-9 shrink-0 items-center justify-center rounded-full font-mono font-extrabold", r.rank === 1 ? "bg-[#1A3323] text-[#FDFCF8]" : r.rank <= 3 ? "bg-[#3D6F4B] text-[#FDFCF8]" : "text-[#1A3323]/60")}>{r.rank}</div>
            <button onClick={() => setViewing(r)} className="relative shrink-0 rounded-full transition-transform hover:scale-105" aria-label={`Lihat foto ${r.display_name}`} data-testid={`leaderboard-avatar-${r.rank}`}>
              <Avatar name={r.display_name} src={r.avatar} size={r.rank <= 3 ? 44 : 36} />
            </button>
            <div className="relative min-w-0 flex-1">
              <div className="truncate font-bold text-[#1A3323]">{r.display_name}{r.is_me && <span className="ml-1 text-xs text-[#3D6F4B]">(kamu)</span>}</div>
              {r.community && <div className="truncate text-[11px] font-semibold text-[#3D6F4B]" data-testid={`leaderboard-community-${r.rank}`}>{r.community}</div>}
              {r.rank === 1 && <div className="text-[11px] font-semibold text-[#3D6F4B]">Paling rajin manjat</div>}
            </div>
            <div className="relative text-right"><div className="font-mono text-xl font-extrabold text-[#1A3323]">{r.completed}</div><div className="text-[10px] text-muted-foreground">climb</div></div>
          </div>
        ))}
      </div>
      <AvatarPopup row={viewing} onClose={() => setViewing(null)} />
    </div>
  );
}

export default function LeaderboardPage() {
  return (
    <div className="space-y-4">
      <div className="rise"><Tape>papan prestasi komunitas</Tape><h1 className="mt-2 text-3xl font-extrabold tracking-tight text-[#1A3323]">Leaderboard</h1><p className="text-sm text-muted-foreground">Siapa yang paling rajin naik wall?</p></div>
      <LeaderboardList endpoint="/leaderboard" />
    </div>
  );
}
